import AuthUser from './AuthUser'
import Config from '../Config';
import Cargando from '../Cargando';
import Mensaje from '../Mensaje';
import CryptoJS from 'crypto-js';
// import { useState } from 'react';
// import variableGLobales from "../Config.jsx";
// import { useLocation, useNavigate } from 'react-router-dom';

const PuenteApi = () => {
    //   const navigate = useNavigate();
    //   const location = useLocation();
    const { SetMensaje } = Mensaje();
    const { StartCargando, StopCargando } = Cargando()
    const { getToken, getLogout, setToken, getModule, getModuleSector } = AuthUser()

    const CerrarSession = async () => {
        StartCargando("Cerrando sesion");
        getLogout();
        const data = {}
        const response = await Config.getLogout(data, getToken())
        if (response.data.sucess) {
            StopCargando();
            return true;
        } else {
            StopCargando();
            SetMensaje("Error", "Error al cerrar sesion", 3000);
            return false;
        }
    }

    const IniciarSession = (user, password, modulo, sector) => {
        Config.getLogin({ user: user, password: password, modulo: modulo, sector: sector })
            .then(async ({ data }) => {
                if (data.sucess) {
                    setToken(
                        data.user,
                        data.token,
                        "client",
                        modulo,
                        sector,
                        data.apodoSector,
                        data.pv
                        // data.user.roles[0].name
                    )
                    StopCargando();
                    // await requestForToken();
                } else {
                    StopCargando();
                    const errorMessages = data.error;
                    const firstErrorKey = Object.keys(errorMessages)[0];
                    const firstErrorMessage = errorMessages[firstErrorKey][0];

                    if (firstErrorKey == 0) {
                        SetMensaje("Error", data.error, 3000);
                    } else {
                        SetMensaje("Error", firstErrorMessage, 3000);
                    }
                }
            })
    }

    const ObtenerProductos = async () => {
        const modulo = getModule();
        const sector = getModuleSector();
        const empleado = "EMPLEADO";
        if (modulo === "" || modulo === null || sector === "" || sector === null) {
            StopCargando();
            SetMensaje("Error", "Error, cierre sesion y vuelva a intentar", 3000);
            return {};
        } else {

            const response = await Config.getproductos({ modulo: modulo, sector: sector, empleado: empleado }, getToken())
            if (response.data.success) {
                return response.data.productos;
            } else {
                const errorMessages = response.data.error;
                const firstErrorKey = Object.keys(errorMessages)[0];
                const firstErrorMessage = errorMessages[firstErrorKey][0];
                if (firstErrorKey == 0) {
                    StopCargando();
                    SetMensaje("Error", response.data.error, 3000);
                } else {
                    StopCargando();
                    SetMensaje("Error", firstErrorMessage, 3000);
                }
                return {};
            }
        }
    }

    const ObtenerProductosPorCodigo = async (codigo) => {
        const modulo = getModule();
        const sector = getModuleSector();
        const empleado = "EMPLEADO";
        if (modulo === "" || modulo === null || sector === "" || sector === null) {
            StopCargando();
            SetMensaje("Error", "Error, cierre sesion y vuelva a intentar", 3000);
            return null;
        } else {

            const response = await Config.getproductoporcodigo({ modulo: modulo, sector: sector, empleado: empleado, codigo: codigo }, getToken())
            if (response.data.success) {
                return response.data.producto;
            } else {
                const errorMessages = response.data.error;
                const firstErrorKey = Object.keys(errorMessages)[0];
                const firstErrorMessage = errorMessages[firstErrorKey][0];
                if (firstErrorKey == 0) {
                    StopCargando();
                    SetMensaje("Error", response.data.error, 1000);
                } else {
                    StopCargando();
                    SetMensaje("Error", firstErrorMessage, 3000);
                }
                return null;
            }
        }
    }

    const ObtenerEmpleados = async () => {
        const modulo = getModule();
        const sector = getModuleSector();
        if (modulo === "" || modulo === null || sector === "" || sector === null) {
            StopCargando();
            SetMensaje("Error", "Error, cierre sesion y vuelva a intentar", 3000);
            return {};
        } else {

            const response = await Config.getempleados({ modulo: modulo, sector: sector }, getToken())
            if (response.data.success) {
                return response.data.empleados;
            } else {
                const errorMessages = response.data.error;
                const firstErrorKey = Object.keys(errorMessages)[0];
                const firstErrorMessage = errorMessages[firstErrorKey][0];
                if (firstErrorKey == 0) {
                    StopCargando();
                    SetMensaje("Error", response.data.error, 3000);
                } else {
                    StopCargando();
                    SetMensaje("Error", firstErrorMessage, 3000);
                }
                return {};
            }
        }
    }

    const VerificarPassEmpleado = async (nombre, apellido, id, contrasenia) => {
        const modulo = getModule();
        const sector = getModuleSector();
        if (modulo === "" || modulo === null || sector === "" || sector === null) {
            StopCargando();
            SetMensaje("Error", "Error, cierre sesion y vuelva a intentar", 3000);
            return false;
        } else {

            const response = await Config.verifypassempleado({ nombre: nombre, apellido: apellido, id: id, contrasenia: contrasenia }, getToken())
            if (response.data.success) {
                return true;
            } else {
                const errorMessages = response.data.error;
                const firstErrorKey = Object.keys(errorMessages)[0];
                const firstErrorMessage = errorMessages[firstErrorKey][0];
                if (firstErrorKey == 0) {
                    StopCargando();
                    SetMensaje("Error", response.data.error, 3000);
                } else {
                    StopCargando();
                    SetMensaje("Error", firstErrorMessage, 3000);
                }
                return false;
            }
        }
    }

    const VerificarPassEmpleadoDespacho = async (nombre, apellido, id, contrasenia) => {
        const modulo = getModule();
        const sector = getModuleSector();
        if (modulo === "" || modulo === null || sector === "" || sector === null) {
            StopCargando();
            SetMensaje("Error", "Error, cierre sesion y vuelva a intentar", 3000);
            return false;
        } else {
            const response = await Config.verifypassempleadodespacho({ nombre: nombre, apellido: apellido, id: id, contrasenia: contrasenia }, getToken())
            if (response.data.success) {
                return true;
            } else {
                const errorMessages = response.data.error;
                const firstErrorKey = Object.keys(errorMessages)[0];
                const firstErrorMessage = errorMessages[firstErrorKey][0];
                if (firstErrorKey == 0) {
                    StopCargando();
                    SetMensaje("Error", response.data.error, 3000);
                } else {
                    StopCargando();
                    SetMensaje("Error", firstErrorMessage, 3000);
                }
                return false;
            }
        }
    }

    const ObtenerClientes = async () => {
        const modulo = getModule();
        const sector = getModuleSector();
        if (modulo === "" || modulo === null || sector === "" || sector === null) {
            StopCargando();
            SetMensaje("Error", "Error, cierre sesion y vuelva a intentar", 3000);
            return {};
        } else {

            const response = await Config.getclientes({ modulo: modulo, sector: sector }, getToken())
            if (response.data.success) {
                return response.data.clientes;
            } else {
                const errorMessages = response.data.error;
                const firstErrorKey = Object.keys(errorMessages)[0];
                const firstErrorMessage = errorMessages[firstErrorKey][0];
                if (firstErrorKey == 0) {
                    StopCargando();
                    SetMensaje("Error", response.data.error, 3000);
                } else {
                    StopCargando();
                    SetMensaje("Error", firstErrorMessage, 3000);
                }
                return {};
            }
        }
    }

    const ObtenerClientesRemito = async () => {
        const modulo = getModule();
        const sector = getModuleSector();
        if (modulo === "" || modulo === null || sector === "" || sector === null) {
            StopCargando();
            SetMensaje("Error", "Error, cierre sesion y vuelva a intentar", 3000);
            return {};
        } else {

            const response = await Config.getclientesremito({ modulo: modulo, sector: sector }, getToken())
            if (response.data.success) {
                return response.data.clientes;
            } else {
                const errorMessages = response.data.error;
                const firstErrorKey = Object.keys(errorMessages)[0];
                const firstErrorMessage = errorMessages[firstErrorKey][0];
                if (firstErrorKey == 0) {
                    StopCargando();
                    SetMensaje("Error", response.data.error, 3000);
                } else {
                    StopCargando();
                    SetMensaje("Error", firstErrorMessage, 3000);
                }
                return {};
            }
        }
    }

    const ObtenerModulos = async () => {
        const response = await Config.getmodules()
        if (response.data.success) {
            return response.data.modulos;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                // console.log("Error", firstErrorMessage, 3000);
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return {};
        }
    }

    const ObtenerUltimaFacturaArca = async (LetraFactura, PuntoDeVenta) => {
        const response = await Config.obtenerultimafacturaarca({ letrafactura: LetraFactura, puntodeventa: PuntoDeVenta }, getToken())
        if (response.data.success) {
            return response.data;
        } else {
            console.log(response)
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                // console.log("Error", firstErrorMessage, 3000);
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return {};
        }
    }

    const ObtenerDatosDeCuitArca = async (cuit) => {
        const response = await Config.obtenerdatosdecuitarca({ cuit: cuit }, getToken())
        if (response.data.success) {
            return response.data;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                // console.log("Error", firstErrorMessage, 3000);
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return response.data;
        }
    }


    const AgregarNuevoCliente = async (dataCliente) => {
        const response = await Config.agregarnuevocliente(dataCliente, getToken())
        if (response.data.success) {
            return true;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return false;
        }
    }

    const EliminarClienteLocal = async (idCliente) => {
        const response = await Config.eliminarcliente({ id: idCliente }, getToken())
        if (response.data.success) {
            return true;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return false;
        }
    }

    const ObtenerUltimaTiradaAlBuzon = async () => {
        const modulo = getModule();
        const sector = getModuleSector();
        const response = await Config.ultimatiradaalbuzon({ modulo: modulo, sector: sector }, getToken())
        if (response.data.success) {
            return response.data.numero;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return -1;
        }
    }

    const AgregarTiradaAlBuzon = async (nombre_empleado, apellido_empleado, id_empleado, numeroTirada, monto, contraseniaEmpleado) => {
        const modulo = getModule();
        const sector = getModuleSector();
        const response = await Config.agregartiradaalbuzon({ modulo: modulo, sector: sector, numtirada: numeroTirada, monto: monto, nombreempleado: nombre_empleado, apellidoempleado: apellido_empleado, idempleado: id_empleado, contraseniaempleado: contraseniaEmpleado }, getToken())
        if (response.data.success) {
            return true;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return false;
        }
    }

    const ObtenerUltimoRemito = async () => {
        const modulo = getModule();
        const sector = getModuleSector();
        const response = await Config.obtenerultimoremito({ modulo: modulo, sector: sector }, getToken())
        if (response.data.success) {
            return response.data.numero;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return -1;
        }
    }

    const ObtenerDespachos = async () => {
        const modulo = getModule();
        const sector = getModuleSector();
        if (modulo === "" || modulo === null || sector === "" || sector === null) {
            StopCargando();
            SetMensaje("Error", "Error, cierre sesion y vuelva a intentar", 3000);
            return {};
        } else {

            const response = await Config.obtenerdespachos({ modulo: modulo, sector: sector }, getToken())
            if (response.data.success) {
                return response.data.despachos;
            } else {
                const errorMessages = response.data.error;
                const firstErrorKey = Object.keys(errorMessages)[0];
                const firstErrorMessage = errorMessages[firstErrorKey][0];
                if (firstErrorKey == 0) {
                    StopCargando();
                    SetMensaje("Error", response.data.error, 3000);
                } else {
                    StopCargando();
                    SetMensaje("Error", firstErrorMessage, 3000);
                }
                return {};
            }
        }
    }

    const ObtenerReporteStock = async (filtros) => {
        const modulo = getModule();
        const sector = getModuleSector();
        const empleado = "EMPLEADO";
        if (modulo === "" || modulo === null || sector === "" || sector === null) {
            StopCargando();
            SetMensaje("Error", "Error, cierre sesion y vuelva a intentar", 3000);
            return {};
        } else {
            const response = await Config.obtenerreportestock({ modulo: modulo, sector: sector, empleado: empleado, filtros: filtros }, getToken())
            if (response.data.success) {
                return response.data.reporte;
            } else {
                const errorMessages = response.data.error;
                const firstErrorKey = Object.keys(errorMessages)[0];
                const firstErrorMessage = errorMessages[firstErrorKey][0];
                if (firstErrorKey == 0) {
                    StopCargando();
                    SetMensaje("Error", response.data.error, 3000);
                } else {
                    StopCargando();
                    SetMensaje("Error", firstErrorMessage, 3000);
                }
                return {};
            }
        }
    }

    const ObtenerFamiliaRubro = async () => {
        const modulo = getModule();
        const sector = getModuleSector();
        const empleado = "EMPLEADO";
        if (modulo === "" || modulo === null || sector === "" || sector === null) {
            StopCargando();
            SetMensaje("Error", "Error, cierre sesion y vuelva a intentar", 3000);
            return null;
        } else {

            const response = await Config.obtenerrubrofamiliastock({ modulo: modulo, sector: sector, empleado: empleado }, getToken())
            if (response.data.success) {
                return response.data;
            } else {
                const errorMessages = response.data.error;
                const firstErrorKey = Object.keys(errorMessages)[0];
                const firstErrorMessage = errorMessages[firstErrorKey][0];
                if (firstErrorKey == 0) {
                    StopCargando();
                    SetMensaje("Error", response.data.error, 1000);
                } else {
                    StopCargando();
                    SetMensaje("Error", firstErrorMessage, 3000);
                }
                return null;
            }
        }
    }

    const IniciarTransaccion = async (items, tipoComanda, subtipoticket, clientecompleto, operarioID, totalFactura, comentarioRemito = "", patente = "") => {
        const modulo = getModule();
        const sector = getModuleSector();
        if (modulo === "" || modulo === null || sector === "" || sector === null) {
            StopCargando();
            SetMensaje("Error", "Error, cierre sesion y vuelva a intentar", 3000);
            return null;
        } else {
            const response = await Config.abriroperacion({ modulo: modulo, sector: sector, productos: items, tipoticket: tipoComanda, subtipoticket: subtipoticket, cliente: clientecompleto, empleado: operarioID, total: totalFactura, comentarioRemito: comentarioRemito, patente: patente }, getToken())
            if (!response) {
                StopCargando();
                SetMensaje("Error en servidor", 2000);
            }
            if (!response.data) {
                StopCargando();
                SetMensaje("Error en servidor", 2000);
            }
            if (response.data.success) {
                return response.data;
            } else {
                const errorMessages = response.data.error;
                const firstErrorKey = Object.keys(errorMessages)[0];
                const firstErrorMessage = errorMessages[firstErrorKey][0];
                if (firstErrorKey == 0) {
                    StopCargando();
                    SetMensaje("Error", response.data.error, 3000);
                } else {
                    StopCargando();
                    SetMensaje("Error", firstErrorMessage, 3000);
                }
                return null;
            }
        }
    }

    const TerminarTransaccion = async (operarioID, totalFactura, idtransaccion, facturaoremito, mediopago, tipoComanda, mensajefin) => {
        const modulo = getModule();
        const sector = getModuleSector();
        if (modulo === "" || modulo === null || sector === "" || sector === null) {
            StopCargando();
            SetMensaje("Error", "Error, cierre sesion y vuelva a intentar", 3000);
            return false;
        } else {
            const response = await Config.terminaroperacion({ modulo: modulo, sector: sector, empleado: operarioID, total: totalFactura, idtransaccion: idtransaccion, facturaoremito: facturaoremito, mediopago: mediopago, tipoticket: tipoComanda, mensajefin: mensajefin }, getToken())
            if (!response) {
                StopCargando();
                SetMensaje("Error en servidor", 2000);
            }
            if (!response.data) {
                StopCargando();
                SetMensaje("Error en servidor", 2000);
            }
            if (response.data.success) {
                return true;
            } else {
                const errorMessages = response.data.error;
                const firstErrorKey = Object.keys(errorMessages)[0];
                const firstErrorMessage = errorMessages[firstErrorKey][0];
                if (firstErrorKey == 0) {
                    StopCargando();
                    SetMensaje("Error", response.data.error, 3000);
                } else {
                    StopCargando();
                    SetMensaje("Error", firstErrorMessage, 3000);
                }
                return false;
            }
        }
    }

    const CancelarTransaccion = async (tipoComanda, idtransaccion, facturaoremito) => {
        const modulo = getModule();
        const sector = getModuleSector();
        if (modulo === "" || modulo === null || sector === "" || sector === null) {
            StopCargando();
            SetMensaje("Error", "Error, cierre sesion y vuelva a intentar", 3000);
            return false;
        } else {
            const response = await Config.cancelaroperacion({ modulo: modulo, sector: sector, tipoticket: tipoComanda, id: idtransaccion, facturaoremito: facturaoremito }, getToken())
            if (response.data.success) {
                return true;
            } else {
                const errorMessages = response.data.error;
                const firstErrorKey = Object.keys(errorMessages)[0];
                const firstErrorMessage = errorMessages[firstErrorKey][0];
                if (firstErrorKey == 0) {
                    StopCargando();
                    SetMensaje("Error", response.data.error, 1000);
                } else {
                    StopCargando();
                    SetMensaje("Error", firstErrorMessage, 3000);
                }
                return false;
            }
        }
    }

    const TestEndPoint = async () => {
        const modulo = getModule();
        const sector = getModuleSector();
        const empleado = "EMPLEADO";
        if (modulo === "" || modulo === null || sector === "" || sector === null) {
            StopCargando();
            SetMensaje("Error", "Error, cierre sesion y vuelva a intentar", 3000);
            return null;
        } else {
            const response = await Config.testendpoint(getToken())
            if (response.data.success) {
                return true;
            } else {
                const errorMessages = response.data.error;
                const firstErrorKey = Object.keys(errorMessages)[0];
                const firstErrorMessage = errorMessages[firstErrorKey][0];
                if (firstErrorKey == 0) {
                    StopCargando();
                    SetMensaje("Error", response.data.error, 1000);
                } else {
                    StopCargando();
                    SetMensaje("Error", firstErrorMessage, 3000);
                }
                return false;
            }
        }
    }

    const imprimirticket = async (items, tipoComanda, subtipoticket, clientecompleto, operarioID, totalFactura, mediopago, idtransaccion, facturaoremito, comentarioRemito = "", patente = "") => {
        const modulo = getModule();
        const sector = getModuleSector();
        if (modulo === "" || modulo === null || sector === "" || sector === null) {
            StopCargando();
            SetMensaje("Error", "Error, cierre sesion y vuelva a intentar", 3000);
            return null;
        } else {
            const data = {
                modulo: modulo,
                sector: sector,
                productos: items,
                tipoticket: tipoComanda,
                subtipoticket: subtipoticket,
                cliente: clientecompleto,
                empleado: operarioID,
                total: totalFactura,
                mediopago: mediopago,
                idtransaccion: idtransaccion,
                facturaoremito: facturaoremito,
                comentarioRemito: comentarioRemito,
                patente: patente,
                reinpresion: false
            };
            const secretKey = process.env.REACT_APP_SECRET_KEY;
            const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
            localStorage.setItem('ticketData', encryptedData);
            const response = await Config.imprimirticket(data, getToken())
            if (response.data.success) {
                return true;
            } else {
                const errorMessages = response.data.error;
                const firstErrorKey = Object.keys(errorMessages)[0];
                const firstErrorMessage = errorMessages[firstErrorKey][0];
                if (firstErrorKey == 0) {
                    StopCargando();
                    SetMensaje("Error", response.data.error, 1000);
                } else {
                    StopCargando();
                    SetMensaje("Error", firstErrorMessage, 3000);
                }
                return false;
            }
        }
    }

    const reimprimirticket = async () => {
        const encryptedData = localStorage.getItem('ticketData');

        const secretKey = process.env.REACT_APP_SECRET_KEY;
        if (encryptedData) {
            const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
            const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            decryptedData.reinpresion = true;
            const response = await Config.imprimirticket(decryptedData, getToken())
            if (response.data.success) {
                return true;
            } else {
                const errorMessages = response.data.error;
                const firstErrorKey = Object.keys(errorMessages)[0];
                const firstErrorMessage = errorMessages[firstErrorKey][0];
                if (firstErrorKey == 0) {
                    StopCargando();
                    SetMensaje("Error", response.data.error, 1000);
                } else {
                    StopCargando();
                    SetMensaje("Error", firstErrorMessage, 3000);
                }
                return false;
            }
        }
    }

    const GenerarFactura = async (concepto, punto_de_venta, tipoComanda, LetraFactura, clientecompleto, ivaArray, transaccionID, totalFactura, netoGravado) => {
        const modulo = getModule();
        const sector = getModuleSector();
        if (modulo === "" || modulo === null || sector === "" || sector === null) {
            StopCargando();
            SetMensaje("Error", "Error, cierre sesion y vuelva a intentar", 3000);
            return null;
        } else {
            const itemConIva0 = ivaArray.find(item => item.porcentaje_iva === "0%");
            const baseImponible0 = itemConIva0?.base_imponible ?? 0;
            const data = {
                concepto: concepto,
                punto_de_venta: Number(punto_de_venta),
                tipo_documento_cliente: "CUIT",
                numero_documento_cliente: Number(clientecompleto.cuit),
                letrafactura: LetraFactura,
                importe_total: Math.ceil(Number(totalFactura) * 100) / 100,
                importe_neto: Math.ceil(Number(netoGravado) * 100) / 100,
                importe_exento: Math.ceil(Number(baseImponible0) * 100) / 100,
                arreglo_de_iva: ivaArray,
                condicion_iva_cliente: clientecompleto.condicion_iva.replace(/ /g, "_"),
                cliente: clientecompleto,
                transaccionID: transaccionID,
                tipoComanda: tipoComanda
            };
            console.log(data)
            const response = await Config.generarfactura(data, getToken())
            if (!response) {
                StopCargando();
                SetMensaje("Error en servidor1", 2000);
            }
            if (!response.data) {
                StopCargando();
                SetMensaje("Error en servidor2", 2000);
            }
            if (response.data.success) {
                return response.data.data;
            } else {
                const errorMessages = response.data.error;
                const firstErrorKey = Object.keys(errorMessages)[0];
                const firstErrorMessage = errorMessages[firstErrorKey][0];
                if (firstErrorKey == 0) {
                    StopCargando();
                    SetMensaje("Error", response.data.error, 3000);
                } else {
                    StopCargando();
                    SetMensaje("Error", firstErrorMessage, 3000);
                }
                return null;
            }
        }
    }

    const ObtenerUltimaComanda = async () => {
        const modulo = getModule();
        const sector = getModuleSector();
        const response = await Config.obtenerultimacomanda({ modulo: modulo, sector: sector }, getToken())
        if (response.data.success) {
            return response.data.numero;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return -1;
        }
    }

    const ObtenerTransaccionesTurno = async () => {
        const modulo = getModule();
        const sector = getModuleSector();
        const response2 = await Config.obtenerfechaultimocierreturno({ modulo: modulo, sector: sector }, getToken())
        if (response2.data.success) {
            const response = await Config.obtenerventasenturno({ modulo: modulo, sector: sector, fecha: response2.data.fecha }, getToken())
            if (response.data.success) {
                return response.data.transacciones;
            } else {
                const errorMessages = response.data.error;
                const firstErrorKey = Object.keys(errorMessages)[0];
                const firstErrorMessage = errorMessages[firstErrorKey][0];
                if (firstErrorKey == 0) {
                    StopCargando();
                    SetMensaje("Error", response.data.error, 3000);
                } else {
                    StopCargando();
                    SetMensaje("Error", firstErrorMessage, 3000);
                }
                return null;
            }
        } else {
            const errorMessages = response2.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response2.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return null;
        }
    }

    const ObtenerPagosIntegrados = async () => {
        const modulo = getModule();
        const sector = getModuleSector();
        const response = await Config.obtenerpagosintegrados({ modulo: modulo, sector: sector }, getToken())
        if (response.data.success) {
            return response.data;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return null;
        }
    }

    const obtenerltimospagos = async (pos_id, store_id) => {
        const modulo = getModule();
        const sector = getModuleSector();
        const response = await Config.obtenerltimospagos({ modulo: modulo, sector: sector, pos_id: pos_id, store_id: store_id }, getToken())
        if (response.data.success) {
            return response.data.movimiento;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return null;
        }
    }

    const verificarPermisoUsuario = async (operarioID, permiso) => {
        const modulo = getModule();
        const sector = getModuleSector();
        const response = await Config.verificarpermisousuario({ modulo: modulo, sector: sector, operarioID: operarioID, permiso: permiso }, getToken())
        if (response.data.success) {
            return true;
        } else {
            return false;
        }
    }

    const CrearOrdenPago = async (pos_id, store_id, importe, tipo) => {
        const modulo = getModule();
        const sector = getModuleSector();
        const response = await Config.crearordendepago({ modulo: modulo, sector: sector, pos_id: pos_id, store_id: store_id, importe: importe, tipo: tipo }, getToken())
        if (response.data.success) {
            return response.data.idorden;
        } else {
            return null;
        }
    }

    const CrearOrdenPagoQrFisico = async (pos_id, store_id, importe, tipo) => {
        const modulo = getModule();
        const sector = getModuleSector();
        console.log({ modulo: modulo, sector: sector, pos_id: pos_id, store_id: store_id, importe: importe, tipo: tipo })
        const response = await Config.crearordendepagoqrfisico({ modulo: modulo, sector: sector, pos_id: pos_id, store_id: store_id, importe: importe, tipo: tipo }, getToken())
        if (response.data.success) {
            return response.data;
        } else {
            return null;
        }
    }

    const ObtenerOrdenPorID = async (order_id) => {
        const modulo = getModule();
        const sector = getModuleSector();
        const response = await Config.obtenerordenporid({ modulo: modulo, sector: sector, order_id: order_id }, getToken())
        if (response.data.success) {
            return response.data.resultado;
        } else {
            return null;
        }
    }

    const obtenerVentasOnline = async (fecha) => {
        const modulo = getModule();
        const sector = getModuleSector();
        const response = await Config.obtenerventasonline({ modulo: modulo, sector: sector, fecha: fecha }, getToken())
        if (response.data.success) {
            return response.data;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return null;
        }
    }

    const ObtenerFechaUltimoCierreTurno = async () => {
        const modulo = getModule();
        const sector = getModuleSector();
        const response2 = await Config.obtenerfechaultimocierreturno({ modulo: modulo, sector: sector }, getToken())
        if (response2.data.success) {
            return response2.data;
        } else {
            const errorMessages = response2.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response2.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return null;
        }
    }

    const ObtenerBonificaciones = async () => {
        const modulo = getModule();
        const sector = getModuleSector();
        const response = await Config.obtenerbonificaciones({ modulo: modulo, sector: sector }, getToken())
        if (response.data.success) {
            return response.data;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return null;
        }
    }

    const ObtenerAforadoresAutomaticos = async () => {
        const modulo = getModule();
        const sector = getModuleSector();
        const response = await Config.obteneraforadoresautomaticos({ modulo: modulo, sector: sector }, getToken())
        console.log(response)
        if (response.data.success) {
            return response.data;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return null;
        }
    }

    const ObtenerAforadoresManuales = async () => {
        const modulo = getModule();
        const sector = getModuleSector();
        const response = await Config.obteneraforadoresmanuales({ modulo: modulo, sector: sector }, getToken())
        if (response.data.success) {
            return response.data.surtidores;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return null;
        }
    }

    const CerrarTurno = async (idempleado, fechainicio, fechafin, imptarjetas, descmp, promociones, aforadoresauto, aforadoresmanual, fondofijo, turnoNro) => {
        const modulo = getModule();
        const sector = getModuleSector();
        // console.log({ modulo: modulo, sector: sector, idEmpleado: idempleado, fechaInicio: fechainicio, fechaFin: fechafin, importeTarjetas: imptarjetas, descMP: descmp, promociones: promociones, aforadoresAuto: aforadoresauto, aforadoresManual: aforadoresmanual, fondoFijo: fondofijo })
        const response = await Config.cerrarturno({ modulo: modulo, sector: sector, idEmpleado: idempleado, fechaInicio: fechainicio, fechaFin: fechafin, importeTarjetas: imptarjetas, descMP: descmp, promociones: promociones, aforadoresAuto: aforadoresauto, aforadoresManual: aforadoresmanual, fondoFijo: fondofijo, turnoNro: turnoNro }, getToken())
        if (response.data.success) {
            return response.data;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return null;
        }
    }

    const ObtenerEstaciones = async () => {
        const modulo = getModule();
        const sector = getModuleSector();
        const response = await Config.obtenerestaciones(getToken())
        if (response.data.success) {
            return response.data.estaciones;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return null;
        }
    }


    //RemoteWork
    const ObtenerModulosPorEndpoint = async (endpoint) => {
        const response = await Config.obtenermodulos(endpoint, getToken())
        if (response.data.success) {
            return response.data.modulos;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return null;
        }
    }

    const AgregarModulo = async (endpoint, data) => {
        console.log(data)
        const response = await Config.agregarmodulo(endpoint, data, getToken())
        if (response.data.success) {
            return true;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return false;
        }
    }

    const obtenerConfiguracionPlayaPorEndpoint = async (endpoint, modulo, sector) => {
        const response = await Config.obtenerconfiguracionplayaporendpoint(endpoint, { modulo: modulo, sector: sector }, getToken())
        if (response.data.success) {
            return response.data;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return null;
        }
    }

    const ActualizarModulo = async (endpoint, data) => {
        StartCargando("Procesando actualizacion...");
        console.log(endpoint, data);
        const response = await Config.actualizarmodulo(endpoint, data, getToken())
        if (response.data.success) {
            StopCargando();
            return true;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                // SetMensaje("Error", response.data.error, 10000);
                return response.data.error;
            } else {
                StopCargando();
                // SetMensaje("Error", firstErrorMessage, 10000);
                return firstErrorMessage;
            }
            return false;
        }
    }

    const EliminarModulo = async (endpoint, data) => {
        StartCargando("Procesando eliminacion...");
        console.log(data)
        const response = await Config.eliminarmodulo(endpoint, data, getToken())
        if (response.data.success) {
            StopCargando();
            return true;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                // SetMensaje("Error", response.data.error, 10000);
                return response.data.error;
            } else {
                StopCargando();
                // SetMensaje("Error", firstErrorMessage, 10000);
                return firstErrorMessage;
            }
            return false;
        }
    }

    const ObtenerCombustiblesPorEndpoint = async (endpoint) => {
        const response = await Config.obtenercombustibles(endpoint, getToken())
        if (response.data.success) {
            return response.data.data;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return null;
        }
    }

    const AgregarCombustible = async (endpoint, data) => {
        const response = await Config.agregarcombustible(endpoint, data, getToken())
        if (response.data.success) {
            return true;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return false;
        }
    }

    const EliminarCombustible = async (endpoint, data) => {
        const response = await Config.eliminarcombustible(endpoint, data, getToken())
        if (response.data.success) {
            return true;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return false;
        }
    }

    const ObtenerMangueras = async (endpoint) => {
        const response = await Config.obtenermangueras(endpoint, getToken())
        if (response.data.success) {
            return response.data.data;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return null;
        }
    }

    const RegistrarFuga = async (endpoint, data) => {
        const response = await Config.registrarfuga(endpoint, data, getToken())
        if (response.data.success) {
            return true;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return false;
        }
    }

    const ObtenerFugas = async (endpoint, data = {}) => {
        const response = await Config.obtenerfugas(endpoint, data, getToken())
        if (response.data.success) {
            return response.data.data;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return null;
        }
    }

    const EliminarFuga = async (endpoint, data) => {
        const response = await Config.eliminarfuga(endpoint, data, getToken())
        if (response.data.success) {
            return true;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return false;
        }
    }

    const ObtenerUsuarios = async (endpoint, data = {}) => {
        const response = await Config.obtenerusuarios(endpoint, data, getToken())
        console.log(response);
        if (response.data.success) {
            return response.data.data;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return null;
        }
    }

    const CrearUsuario = async (endpoint, data) => {
        const response = await Config.crearusuario(endpoint, data, getToken())
        if (response.data.success) {
            return true;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return false;
        }
    }

    const ActualizarUsuario = async (endpoint, data) => {
        const response = await Config.actualizarusuario(endpoint, data, getToken())
        if (response.data.success) {
            return true;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return false;
        }
    }

    const EliminarUsuario = async (endpoint, data) => {
        const response = await Config.eliminarusuario(endpoint, data, getToken())
        if (response.data.success) {
            return true;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return false;
        }
    }

    const CambiarPasswordUsuario = async (endpoint, data) => {
        const response = await Config.cambiarpasswordusuario(endpoint, data, getToken())
        if (response.data.success) {
            return true;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return false;
        }
    }

    const ObtenerRoles = async (endpoint, data = {}) => {
        const response = await Config.obtenerroles(endpoint, data, getToken())
        if (response.data.success) {
            return response.data.data;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return null;
        }
    }

    const AsignarRoles = async (endpoint, data) => {
        const response = await Config.asignarroles(endpoint, data, getToken())
        if (response.data.success) {
            return true;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return false;
        }
    }

    const ObtenerEmpleadosAdmin = async (endpoint, data = {}) => {
        const response = await Config.obtenerempleadosadmin(endpoint, getToken())
        if (response.data.success) {
            return response.data.data;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return null;
        }
    }

    const CrearEmpleado = async (endpoint, data = {}) => {
        const response = await Config.crearempleado(endpoint, data, getToken())
        if (response.data.success) {
            return true;
        } else {
            if (response.data.error) {
                // ManejoError(response.data.error)
            }
            return false;
        }
    }

    const ActualizarEmpleado = async (endpoint, data = {}) => {
        const response = await Config.actualizarempleado(endpoint, data, getToken())
        if (response.data.success) {
            return true;
        } else {
            if (response.data.error) {
                // ManejoError(response.data.error)
            }
            return false;
        }
    }

    const EliminarEmpleado = async (endpoint, data = {}) => {
        const response = await Config.eliminarempleado(endpoint, data, getToken())
        if (response.data.success) {
            return true;
        } else {
            if (response.data.error) {
                // ManejoError(response.data.error)
            }
            return false;
        }
    }

    const CambiarPasswordEmpleado = async (endpoint, data = {}) => {
        const response = await Config.cambiarpasswordempleado(endpoint, data, getToken())
        if (response.data.success) {
            return true;
        } else {
            if (response.data.error) {
                // ManejoError(response.data.error)
            }
            return false;
        }
    }

    // Clientes
    const ObtenerClientesAdmin = async (endpoint, data = {}) => {
        const response = await Config.obtenerclientesadmin(endpoint, getToken())
        if (response.data.success) {
            return response.data.data;
        } else {
            return null;
        }
    }

    const CrearCliente = async (endpoint, data = {}) => {
        const response = await Config.crearcliente(endpoint, data, getToken())
        if (response.data.success) {
            return true;
        } else {
            return false;
        }
    }

    const ActualizarCliente = async (endpoint, data = {}) => {
        const response = await Config.actualizarcliente(endpoint, data, getToken())
        if (response.data.success) {
            return true;
        } else {
            return false;
        }
    }

    const EliminarCliente = async (endpoint, data = {}) => {
        const response = await Config.eliminarcliente(endpoint, data, getToken())
        if (response.data.success) {
            return true;
        } else {
            return false;
        }
    }

    const ObtenerTanquesPorEndpoint = async (endpoint, data = {}) => {
        const response = await Config.obtenerTanques(endpoint, getToken())
        if (response.data.success) {
            return response.data.tanques;
        } else {
            return null;
        }
    }

    const AgregarTanque = async (endpoint, data) => {
        console.log(data);
        const response = await Config.agregarTanques(endpoint, data, getToken())
        if (response.data.success) {
            return true;
        } else {
            SetMensaje("Error", response.data.error, 3000);
            return false;
        }
    }

    const ActualizarTanque = async (endpoint, data) => {
        const response = await Config.actualizarTanque(endpoint, data, getToken())
        if (response.data.success) {
            return true;
        } else {
            SetMensaje("Error", response.data.error, 3000);
            return false;
        }
    }

    const EliminarTanque = async (endpoint, data) => {
        const response = await Config.eliminarTanques(endpoint, data, getToken())
        if (response.data.success) {
            return true;
        } else {
            if (response.data.error) {
                SetMensaje("Error", response.data.error, 3000);
            }
            return false;
        }
    }

    const RegistrarMovimientoTanque = async (endpoint, data) => {
        const response = await Config.registrarMovimientoTanque(endpoint, data, getToken())
        if (response.data.success) {
            return true;
        } else {
            if (response.data.error) {
                SetMensaje("Error", response.data.error, 3000);
            }
            return false;
        }
    }

    const ObtenerCierresTurnos = async (endpoint, filtros = {}) => {
        const token = getToken();
        if (!token) return null;
        const response = await Config.obtenercierresturnos(endpoint, filtros, token);
        if (response.data.success) {
            return response.data.cierres;
        } else {
            console.error(response.data.error);
            return null;
        }
    }

    const ObtenerDetalleCierreTurno = async (endpoint, id) => {
        const response = await Config.obtenerdetallecierreturno(endpoint, { id: id }, getToken())
        if (response.data.success) {
            return response.data;
        } else {
            const errorMessages = response.data.error;
            const firstErrorKey = Object.keys(errorMessages)[0];
            const firstErrorMessage = errorMessages[firstErrorKey][0];
            if (firstErrorKey == 0) {
                StopCargando();
                SetMensaje("Error", response.data.error, 3000);
            } else {
                StopCargando();
                SetMensaje("Error", firstErrorMessage, 3000);
            }
            return null;
        }
    }

    const ActualizarCierreTurno = async (endpoint, data) => {
        const response = await Config.actualizarcierreturno(endpoint, data, getToken())
        if (response && response.data && response.data.success) {
            return response.data;
        } else {
            return response?.data || { success: false, error: "Error desconocido" };
        }
    }

    const ObtenerTiradasAlBuzon = async (endpoint, filtros = {}) => {
        const token = getToken();
        if (!token) return null;
        const response = await Config.obtenertiradasalbuzonadmin(endpoint, filtros, token);
        if (response && response.data && response.data.success) {
            return response.data.tiradas;
        } else {
            console.error(response?.data?.error || "Error al obtener tiradas");
            return null;
        }
    }

    const ActualizarTiradaAlBuzon = async (endpoint, data) => {
        const token = getToken();
        if (!token) return null;
        const response = await Config.actualizartiradaalbuzonadmin(endpoint, data, token);
        if (response && response.data && response.data.success) {
            return response.data;
        } else {
            return response?.data || { success: false, error: "Error desconocido" };
        }
    }

    const EliminarTiradaAlBuzon = async (endpoint, id) => {
        const token = getToken();
        if (!token) return null;
        const response = await Config.eliminartiradaalbuzonadmin(endpoint, { id: id }, token);
        if (response && response.data && response.data.success) {
            return response.data;
        } else {
            return response?.data || { success: false, error: "Error desconocido" };
        }
    }

    // Provedores
    const ObtenerProvedoresAdmin = async (endpoint) => {
        const response = await Config.obtenerprovedoresadmin(endpoint, getToken())
        if (response.data.success) {
            return response.data.provedores;
        } else {
            SetMensaje("Error", "Error al obtener proveedores", 3000);
            return [];
        }
    }

    const CrearProvedor = async (endpoint, data) => {
        const response = await Config.crearprovedor(endpoint, data, getToken())
        if (response && response.data && response.data.success) {
            return true;
        } else {
            if (response && response.data && response.data.error) {
                SetMensaje("Error", response.data.error, 3000);
            }
            return false;
        }
    }

    const ActualizarProvedor = async (endpoint, id, data) => {
        const response = await Config.actualizarprovedor(endpoint, id, data, getToken())
        if (response && response.data && response.data.success) {
            return true;
        } else {
            if (response && response.data && response.data.error) {
                SetMensaje("Error", response.data.error, 3000);
            }
            return false;
        }
    }

    const EliminarProvedor = async (endpoint, id) => {
        const response = await Config.eliminarprovedor(endpoint, id, getToken())
        if (response && response.data && response.data.success) {
            return true;
        } else {
            if (response && response.data && response.data.error) {
                SetMensaje("Error", response.data.error, 3000);
            }
            return false;
        }
    }

    const ObtenerProvedoresFamilias = async (endpoint) => {
        const response = await Config.obtenerprovedoresfamilias(endpoint, getToken())
        if (response && response.data && response.data.success) {
            return response.data.familias;
        } else {
            SetMensaje("Error", "Error al obtener familias de proveedores", 3000);
            return [];
        }
    }

    const CrearProvedorFamilia = async (endpoint, data) => {
        const response = await Config.crearprovedorfamilia(endpoint, data, getToken())
        if (response && response.data && response.data.success) {
            return true;
        } else {
            if (response && response.data && response.data.error) {
                SetMensaje("Error", response.data.error, 3000);
            }
            return false;
        }
    }

    const ActualizarProvedorFamilia = async (endpoint, id, data) => {
        const response = await Config.actualizarprovedorfamilia(endpoint, id, data, getToken())
        if (response && response.data && response.data.success) {
            return true;
        } else {
            if (response && response.data && response.data.error) {
                SetMensaje("Error", response.data.error, 3000);
            }
            return false;
        }
    }

    const EliminarProvedorFamilia = async (endpoint, id) => {
        const response = await Config.eliminarprovedorfamilia(endpoint, id, getToken())
        if (response && response.data && response.data.success) {
            return true;
        } else {
            if (response && response.data && response.data.error) {
                SetMensaje("Error", response.data.error, 3000);
            }
            return false;
        }
    }

    const ObtenerRazonesSociales = async (endpoint) => {
        const response = await Config.obtenerrazonessociales(endpoint, getToken())
        if (response && response.data && response.data.success) {
            return response.data.razones;
        } else {
            SetMensaje("Error", "Error al obtener razones sociales", 3000);
            return [];
        }
    }

    const CrearRazonSocial = async (endpoint, data) => {
        const response = await Config.crearrazonsocial(endpoint, data, getToken())
        if (response && response.data && response.data.success) {
            return true;
        } else {
            if (response && response.data && response.data.error) {
                SetMensaje("Error", response.data.error, 3000);
            }
            return false;
        }
    }

    const ActualizarRazonSocial = async (endpoint, id, data) => {
        const response = await Config.actualizarrazonsocial(endpoint, id, data, getToken())
        if (response && response.data && response.data.success) {
            return true;
        } else {
            if (response && response.data && response.data.error) {
                SetMensaje("Error", response.data.error, 3000);
            }
            return false;
        }
    }

    const EliminarRazonSocial = async (endpoint, id) => {
        const response = await Config.eliminarrazonsocial(endpoint, id, getToken())
        if (response && response.data && response.data.success) {
            return true;
        } else {
            if (response && response.data && response.data.error) {
                SetMensaje("Error", response.data.error, 3000);
            }
            return false;
        }
    }

    const ObtenerComprobantesProveedor = async (endpoint, filtros) => {
        const response = await Config.obtenerprovedorescomprobantes(endpoint, filtros, getToken())
        if (response && response.data && response.data.success) {
            return response.data.comprobantes;
        } else {
            SetMensaje("Error", "Error al obtener comprobantes", 3000);
            return { data: [] }; // Return object matching pagination structure if backend sends pagination
        }
    }

    const CrearComprobanteProveedor = async (endpoint, data) => {
        const response = await Config.crearprovedorcomprobante(endpoint, data, getToken())
        if (response && response.data && response.data.success) {
            return true;
        } else {
            if (response && response.data && response.data.error) {
                // If it's a validation error object
                if (typeof response.data.error === 'object') {
                    // Just show the first error for now or generic message
                    SetMensaje("Error", "Error de validación", 3000);
                } else {
                    SetMensaje("Error", response.data.error, 3000);
                }
            } else if (response && response.data && response.data.errors) {
                SetMensaje("Error", "Error de validación", 3000);
            }
            else {
                SetMensaje("Error", "Error al crear comprobante", 3000);
            }
            return false;
        }
    }

    const ActualizarComprobanteProveedor = async (endpoint, id, data) => {
        const response = await Config.actualizarprovedorcomprobante(endpoint, id, data, getToken())
        if (response && response.data && response.data.success) {
            return true;
        } else {
            if (response && response.data && response.data.error) {
                if (typeof response.data.error === 'object') {
                    SetMensaje("Error", "Error de validación", 3000);
                } else {
                    SetMensaje("Error", response.data.error, 3000);
                }
            } else {
                SetMensaje("Error", "Error al actualizar comprobante", 3000);
            }
            return false;
        }
    }

    const EliminarComprobanteProveedor = async (endpoint, id) => {
        const response = await Config.eliminarprovedorcomprobante(endpoint, id, getToken())
        if (response && response.data && response.data.success) {
            return true;
        } else {
            SetMensaje("Error", "Error al eliminar comprobante", 3000);
            return false;
        }
    }



    return ({
        getToken,
        getLogout,
        setToken,
        getModule,
        getModuleSector,
        CerrarSession,
        IniciarSession,
        ObtenerProductos,
        ObtenerProductosPorCodigo,
        ObtenerEmpleados,
        VerificarPassEmpleado,
        ObtenerClientes,
        ObtenerClientesRemito,
        ObtenerModulos,
        ObtenerUltimaFacturaArca,
        ObtenerDatosDeCuitArca,
        AgregarNuevoCliente,
        EliminarClienteLocal,
        ObtenerUltimaTiradaAlBuzon,
        AgregarTiradaAlBuzon,
        ObtenerUltimoRemito,
        VerificarPassEmpleadoDespacho,
        ObtenerDespachos,
        ObtenerReporteStock,
        ObtenerFamiliaRubro,
        TestEndPoint,
        IniciarTransaccion,
        imprimirticket,
        CancelarTransaccion,
        TerminarTransaccion,
        GenerarFactura,
        ObtenerUltimaComanda,
        ObtenerTransaccionesTurno,
        ObtenerPagosIntegrados,
        obtenerltimospagos,
        verificarPermisoUsuario,
        CrearOrdenPago,
        ObtenerOrdenPorID,
        CrearOrdenPagoQrFisico,
        ObtenerEmpleadosAdmin,
        CrearEmpleado,
        ActualizarEmpleado,
        EliminarEmpleado,
        CambiarPasswordEmpleado,
        obtenerVentasOnline,
        ObtenerFechaUltimoCierreTurno,
        reimprimirticket,
        ObtenerBonificaciones,
        ObtenerAforadoresAutomaticos,
        ObtenerAforadoresManuales,
        CerrarTurno,
        ObtenerEstaciones,
        ObtenerModulosPorEndpoint,
        AgregarModulo,
        obtenerConfiguracionPlayaPorEndpoint,
        ActualizarModulo,
        EliminarModulo,
        ObtenerCombustiblesPorEndpoint,
        AgregarCombustible,
        EliminarCombustible,
        ObtenerMangueras,
        RegistrarFuga,
        ObtenerFugas,
        EliminarFuga,
        ObtenerUsuarios,
        CrearUsuario,
        ActualizarUsuario,
        EliminarUsuario,
        CambiarPasswordUsuario,
        ObtenerRoles,
        AsignarRoles,
        ObtenerClientesAdmin,
        CrearCliente,
        ActualizarCliente,
        EliminarCliente,
        ObtenerTanquesPorEndpoint,
        AgregarTanque,
        ActualizarTanque,
        EliminarTanque,
        RegistrarMovimientoTanque,
        ObtenerCierresTurnos,
        ObtenerDetalleCierreTurno,
        ActualizarCierreTurno,
        ObtenerTiradasAlBuzon,
        ActualizarTiradaAlBuzon,
        EliminarTiradaAlBuzon,
        ObtenerProvedoresAdmin,
        CrearProvedor,
        ActualizarProvedor,
        EliminarProvedor,
        ObtenerProvedoresFamilias,
        CrearProvedorFamilia,
        ActualizarProvedorFamilia,
        EliminarProvedorFamilia,
        ObtenerRazonesSociales,
        CrearRazonSocial,
        ActualizarRazonSocial,
        ObtenerRazonesSociales,
        CrearRazonSocial,
        ActualizarRazonSocial,
        EliminarRazonSocial,
        ObtenerComprobantesProveedor,
        CrearComprobanteProveedor,
        ActualizarComprobanteProveedor,
        EliminarComprobanteProveedor
    }
    )
}

export default PuenteApi
